module.exports = __webpack_public_path__ + "static/media/luggage.76ca472a.jpg";